import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { ReactionType } from "../interfaces/types";
import { REACTIONS } from "../../../data/Reactions";

type Props = {
  onSelect: (r: ReactionType) => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  col?:boolean;
};

const ReactionPicker: React.FC<Props> = ({
  onSelect,
  onMouseEnter,
  onMouseLeave,
  col
}) => (
  <div
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    className={`" ${col ? 'flex-col':'flex-row'}
      absolute
      left-1/2 -translate-x-1/2
      -top-10
      flex
      items-center
      gap-2
      bg-white dark:bg-deepSlate
      shadow-xl
      rounded-full
      px-3 py-2
      z-50
    "`}
  >
    {REACTIONS.map(r => (
      <motion.button
        key={r.type}
        type="button"
        whileHover={{ scale: 1.4, y: -6 }}
        whileTap={{ scale: 1.2 }}
        onClick={() => onSelect(r.type)}
        className={`${r.color} cursor-pointer`}
      >
        <Icon icon={r.icon} className="w-7 h-7" />
      </motion.button>
    ))}
  </div>
);

export default ReactionPicker;
